import type { AdGraphExplorePresetDto } from '@terra/shared-contracts-internal-network';

export const INTERNAL_NETWORK_GRAPH_EXPLORE_PRESETS = [
  'crown-jewels',
  'owned-to-targets',
  'domain-admins',
  'domain-controllers',
  'kerberoastable-users',
  'as-rep-roastable',
  'dcsync-paths',
  'unconstrained-delegation',
] as const satisfies readonly AdGraphExplorePresetDto[];

export const INTERNAL_NETWORK_GRAPH_EXPLORE_PRESET_LABELS: Record<
  AdGraphExplorePresetDto,
  string
> = {
  'crown-jewels': 'Crown jewels',
  'owned-to-targets': 'Owned to targets',
  'domain-admins': 'Domain admins',
  'domain-controllers': 'Domain controllers',
  'kerberoastable-users': 'Kerberoastable users',
  'as-rep-roastable': 'AS-REP roastable',
  'dcsync-paths': 'DCSync paths',
  'unconstrained-delegation': 'Unconstrained delegation',
};

export function resolveFirstAvailableExplorePreset({
  crownJewelCount,
  ownedPrincipalCount = 0,
  skipCrownJewels = false,
}: {
  crownJewelCount: number;
  ownedPrincipalCount?: number;
  skipCrownJewels?: boolean;
}): AdGraphExplorePresetDto {
  for (const preset of INTERNAL_NETWORK_GRAPH_EXPLORE_PRESETS) {
    if (
      preset === 'crown-jewels' &&
      (crownJewelCount === 0 || skipCrownJewels)
    ) {
      continue;
    }
    if (preset === 'owned-to-targets' && ownedPrincipalCount === 0) {
      continue;
    }
    return preset;
  }

  return 'domain-admins';
}

export function getInternalNetworkAdEntityKindCount({
  stats,
  kind,
}: {
  stats:
    | {
        totalUsers?: number;
        totalGroups?: number;
        totalComputers?: number;
        totalOus?: number;
        totalDomains?: number;
        totalGpos?: number;
        totalDomainControllers?: number;
        totalCertTemplates?: number;
        totalContainers?: number;
        totalCanonicalAssets?: number;
      }
    | undefined;
  kind: string | null;
}): number {
  if (!stats) {
    return 0;
  }

  if (!kind) {
    return (
      (stats.totalUsers ?? 0) +
      (stats.totalGroups ?? 0) +
      (stats.totalComputers ?? 0) +
      (stats.totalOus ?? 0) +
      (stats.totalDomains ?? 0) +
      (stats.totalGpos ?? 0) +
      (stats.totalDomainControllers ?? 0) +
      (stats.totalCertTemplates ?? 0) +
      (stats.totalContainers ?? 0)
    );
  }

  if (kind === 'CANONICAL') {
    return stats.totalCanonicalAssets ?? 0;
  }

  const countByKind: Record<string, number> = {
    USER: stats.totalUsers ?? 0,
    GROUP: stats.totalGroups ?? 0,
    COMPUTER: stats.totalComputers ?? 0,
    OU: stats.totalOus ?? 0,
    DOMAIN: stats.totalDomains ?? 0,
    GPO: stats.totalGpos ?? 0,
    DOMAIN_CONTROLLER: stats.totalDomainControllers ?? 0,
    CERT_TEMPLATE: stats.totalCertTemplates ?? 0,
    CONTAINER: stats.totalContainers ?? 0,
  };

  return countByKind[kind] ?? 0;
}
